// ─── RAZORPAY CLIENT SERVICE ─────────────────────────────────────────
// Talks to our own server (secret key stays server-side):
//   POST /payments/razorpay/order   → create an order
//   POST /payments/razorpay/verify  → verify the payment signature
// and opens the Razorpay Checkout widget in the browser.
import { apiPost } from './auth';

const CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

function loadCheckout() {
  return new Promise((resolve, reject) => {
    if (typeof window !== "undefined" && window.Razorpay) return resolve();
    const s = document.createElement("script");
    s.src = CHECKOUT_SRC;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Could not load Razorpay Checkout. Check your connection."));
    document.body.appendChild(s);
  });
}

export const RazorpayService = {
  // Create an order on the server. Returns { id, amount, currency, keyId }.
  async createOrder(invoice, amount) {
    return apiPost("/payments/razorpay/order", {
      amount,
      invoiceNo: invoice.invoiceNo,
      invoiceId: invoice.id,
      notes: { invoiceNo: invoice.invoiceNo, clientName: invoice.clientName },
    });
  },

  // Verify a completed payment on the server. Returns { success }.
  async verify(payload) {
    return apiPost("/payments/razorpay/verify", payload);
  },

  // Open Razorpay Checkout. Resolves with the payment response object,
  // rejects if the user dismisses the modal or the payment fails.
  openCheckout({ order, invoice, customer, method, orgName }) {
    return new Promise(async (resolve, reject) => {
      try { await loadCheckout(); } catch (e) { return reject(e); }
      const methodMap = { upi: "upi", card: "card", nb: "netbanking", emi: "emi" };
      const rzp = new window.Razorpay({
        key: order.keyId,
        order_id: order.id,
        amount: order.amount,
        currency: order.currency || "INR",
        name: orgName || "Founders Bridge",
        description: `Invoice ${invoice.invoiceNo}`,
        prefill: {
          name: customer?.name || "",
          email: customer?.email || "",
          contact: customer?.phone || "",
          method: methodMap[method] || undefined,
        },
        theme: { color: "#1E40AF" },
        handler: (response) => resolve(response),
        modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
      });
      rzp.on("payment.failed", (resp) =>
        reject(new Error(resp?.error?.description || "Payment failed")));
      rzp.open();
    });
  },
};

export default RazorpayService;
